import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useAppUser } from '../auth/AppUserContext';
import type { Role } from '../data/types';

/** Route guard: renders children only when the app user has one of `roles`. */
export function RequireRole({
  roles,
  children,
}: {
  roles: readonly Role[];
  children: ReactNode;
}) {
  const { user } = useAppUser();
  const location = useLocation();
  if (!user || !roles.includes(user.role)) {
    // Home says why (round 5: a store user was sent back without a word).
    return <Navigate to="/" replace state={user ? { deniedFrom: location.pathname } : undefined} />;
  }
  return <>{children}</>;
}
